import AbilityScoresHelp from "./AbilityScoresHelp";

export default AbilityScoresHelp;
export { AbilityScoresHelp };
